export default __webpack_public_path__ + "static/media/clean2.61cec9a3.png";